import { TableHorizontalAlignment, TableVerticalAlignment } from '@lib/types/component-table'
import { CSSProperties } from 'react'

export const verticalAlignMap: Record<TableVerticalAlignment, CSSProperties['verticalAlign']> = {
  [TableVerticalAlignment.Top]: 'top',
  [TableVerticalAlignment.Center]: 'middle',
  [TableVerticalAlignment.Bottom]: 'bottom',
}

export const horizontalAlignMap: Record<TableHorizontalAlignment, CSSProperties['textAlign']> = {
  [TableHorizontalAlignment.Left]: 'left',
  [TableHorizontalAlignment.Center]: 'center',
  [TableHorizontalAlignment.Right]: 'right',
}
